export function removeTrailingSlash(path) {
  return path.replace(/^(.+?)\/+$/, '$1');
}
